import { Divider, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import useMediaQuery from '@mui/material/useMediaQuery'
import React, { useContext } from 'react'
import ProductImages from './components/ProductImages'
import ProductDetails from './components/ProductDetails'
import ProductFeedbacksView from './components/ProductFeedbacks/ProductFeedbacksView'
import RecentlyViewed from '@components/RecentlyViewed/RecentlyViewed'
import Breadcrumbs from './components/Breadcrumbs'
import ProductDescription from './components/ProductDescription'
import ProductContext from './context/ProductContext'
import ProductOverview from './components/ProductOverview'

interface IProps {
  onGooglePushProductDetails(): void

  isModal?: boolean
  initialId?: string | number
}

const Page: React.FC<IProps> = ({ onGooglePushProductDetails, isModal, initialId }) => {
  const { reflection } = useContext(ProductContext)
  const theme = useTheme()
  const xsDown = useMediaQuery(theme.breakpoints.down('xs'))
  const smOnly = useMediaQuery(theme.breakpoints.only('sm'))
  return (
    <div id='content'>
      <div className='px-10 md:py-20 sm:px-32 xl:px-0'>
        <Breadcrumbs />
        <Grid container spacing={smOnly ? 2 : xsDown ? 0 : 4}>
          <Grid item xs={12}>
            <div className='block md:hidden'>
              <h1 className='font-semibold text-3xl leading-tight' itemProp='name'>
                {reflection?.name}
              </h1>
              <ProductOverview text={reflection?.generatedDescription} />
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <ProductImages onGooglePushProductDetails={onGooglePushProductDetails} />
          </Grid>
          <Grid item xs={12} md={5} lg={4} style={{ position: 'relative' }}>
            <ProductDetails onGooglePushProductDetails={onGooglePushProductDetails} />
            <div>
              <ProductFeedbacksView initialId={initialId} />
            </div>
          </Grid>
          <Grid item xs={12}>
            <ProductDescription description={reflection?.description} />
          </Grid>
          <Grid item xs={12}>
            <div className='max-w-lg mx-auto'>
              <RecentlyViewed slidesPerView={4} />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}

export default React.memo(Page)
